export default {"src":"/_next/static/media/transit-airport.49b83380.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};